import { render, staticRenderFns } from "./home_menu.vue?vue&type=template&id=df2f34ba&scoped=true"
import script from "./home_menu.vue?vue&type=script&lang=js"
export * from "./home_menu.vue?vue&type=script&lang=js"
import style0 from "./home_menu.vue?vue&type=style&index=0&id=df2f34ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2f34ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df2f34ba')) {
      api.createRecord('df2f34ba', component.options)
    } else {
      api.reload('df2f34ba', component.options)
    }
    module.hot.accept("./home_menu.vue?vue&type=template&id=df2f34ba&scoped=true", function () {
      api.rerender('df2f34ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_menu.vue"
export default component.exports